import {useMemo} from "react";
import {useTranslation} from "react-i18next";
import {IHomeSteps} from "../../../store/home/Helper";

const useHowItWorksJsonLd = (steps: IHomeSteps[] = []) => {
    const {i18n, t} = useTranslation()

    const content = useMemo(() => (
        {
            "@context": "https://schema.org",
            "@type": "HowTo",
            "name": `${t('how_it_works')} - Genie`,
            "description": t('how_it_works_jsonld_description'),
            "url": window.location.href,
            "steps": (steps ?? []).map((s) => ({
                "@type": "HowToStep",
                "name": s[`label_${i18n.language}`],
                "text": s[`label_${i18n.language}`]
            }))
        }
    ), [steps, i18n.language, t])
    return {content}
}

export default useHowItWorksJsonLd
